<template>
	<div>
	 <radio-list :question="question" @go-next="goNext(score)"></radio-list>
	</div>
</template>
<script>
  import RadioList from './radioList.vue'
  export default {
    components: { RadioList },
    events: {
      goNext (score, answer) {
        this.$dispatch('changeView', 'q5', score, answer)
      }
    },
    data () {
      return {
        question: {
          title: '您的住房情况',
          qId: 'q4',
          options: [{
            text: '短期租房',
            score: 0,
            aId: 'a1'
          }, {
            text: '长期租房',
            score: 2,
            aId: 'a2'
          }, {
            text: '自有房产价值低于100万',
            score: 18,
            aId: 'a3'
          }, {
            text: '自有房产价值大于100万',
            score: 24,
            aId: 'a4'
          }, {
            text: '其他',
            score: -2,
            aId: 'a5'
          }]
        }
      }
    }
}

</script>



/** WEBPACK FOOTER **
 ** q4.vue?b315ba26
 **/